module.exports = __webpack_public_path__ + "img/battery.dffe8deb.svg";